'use strict';

customerZone

/**
 * A selector for payment methods.
 *
 * This component can be used by binding it (using the ngModel parameter) to a backing object.
 * At any time, use the backing object by invoking the getPaymentMethod method on it,  as
 * such: paymentMethodSelection.getPaymentMethod(allowedMethods).  This will return a promise
 * to the selected method, which will resolve after a user has selected a method.
 */
.component('paymentMethodSelector', {
    bindings: {
        ngModel: '='
    },
    templateUrl: customerZone.fromBase('components/payment-method-selector/payment-method-selector.component.html'),
    controllerAs: 'vm',
    controller: ['$q', function($q){
        var vm = this;

        var LABELS = {
            'KBC/CBC Payment Button': 'KBC/CBC',
            'Belfius Payment Button': 'Belfius'
        };

        var ICONS = {
            'KBC/CBC Payment Button': 'kbc.gif',
            'Belfius Payment Button': 'belfius.gif',
            'Bancontact': 'bancontact.svg',
            'Bitcoin': 'bitcoin.svg',
            'Mastercard': 'mastercard.svg',
            'Paypal': 'paypal.svg',
            'VISA': 'visa.svg'
        };

        vm.displaySelection = false;
        vm.allowedMethods = [];
        var deferredSelection;

        vm.selectMethod = function(method){
            vm.displaySelection = false;
            resolvePromise(method);
        };

        var showSelection = function(){
            vm.displaySelection = true;
        };

        var resolvePromise = function(selectedMethod){
            deferredSelection.resolve(selectedMethod);
            deferredSelection = null;
        };

        /**
         * Display the selection modal and return a promise to the chosen method.
         * @param options: string[] The payment options to pick from.
         * @return Promise<String> for the selected payment method.
         */
        var getPaymentMethod = function(options){
            if (!deferredSelection) {
                if (options.length === 1)
                    return $q.when(options[0]);
                vm.allowedMethods = options.map(stringToOption);
                showSelection();
                deferredSelection = $q.defer();
            }
            return deferredSelection.promise;
        };

        var stringToOption = function(string){
            return {
                id: string,
                label: LABELS[string] || string,
                icon: ICONS[string] || (string + '.gif')
            };
        };

        vm.$onInit = function(){
            /*
             * We assign an object to the model binding here, with the purpose of injecting
             * it into the using controller.  This will allow the controller to use or pass on
              * this callback at any time in order to invoke the selection.
             */
            vm.ngModel = {
                getPaymentMethod: getPaymentMethod
            };
        };
    }]
});
